import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "./LangContext";
import { AuthProvider } from "./AuthContext";
import { TenantProvider } from "./TenantContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Hero from "./Hero";
import { IlBorgo, GemelloDigitale, AttrazioniPreview, ImmobiliMapTeaser } from "./HomeSections";
import { EventsPreview, ContactSection } from "./EventsAndContact";
import Chatbot from "./Chatbot";
import EventiPage from "./pages/EventiPage";
import AttrazioniPage from "./pages/AttrazioniPage";
import GemelloDigitalePage from "./pages/GemelloDigitalePage";
import ImmobiliListPage from "./pages/ImmobiliListPage";
import ImmobileDetailPage from "./pages/ImmobileDetailPage";
import ItinerariPage from "./pages/ItinerariPage";
import ItinerarioDetailPage from "./pages/ItinerarioDetailPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./admin/AdminDashboard";
import SuperAdminPage from "./pages/SuperAdminPage";
import { useTenant } from "./TenantContext";

const Home = () => {
    const { tenant } = useTenant();
    const modules = tenant?.modules || {};
    const on = (k) => modules[k] !== false;
    return (
        <>
            <Hero />
            <IlBorgo />
            {on("digital_twin") && <GemelloDigitale />}
            {on("attrattori") && <AttrazioniPreview />}
            {on("immobili") && <ImmobiliMapTeaser />}
            {on("eventi") && <EventsPreview />}
            <ContactSection />
        </>
    );
};

function App() {
    return (
        <div className="App notranslate" translate="no">
            <AuthProvider>
                <TenantProvider>
                    <LangProvider>
                        <HashRouter>
                            <Navbar />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/eventi" element={<EventiPage />} />
                                <Route path="/attrazioni" element={<AttrazioniPage />} />
                                <Route path="/gemello-digitale" element={<GemelloDigitalePage />} />
                                <Route path="/immobili" element={<ImmobiliListPage />} />
                                <Route path="/immobili/:id" element={<ImmobileDetailPage />} />
                                <Route path="/itinerari" element={<ItinerariPage />} />
                                <Route path="/itinerari/:id" element={<ItinerarioDetailPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/super-admin" element={<SuperAdminPage />} />
                            </Routes>
                            <Footer />
                            <Chatbot />
                        </HashRouter>
                    </LangProvider>
                </TenantProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
